const state = {
  productsConfigDialog: false,
  currentPage: '',
  snackbarColor: 'primary',
  snackbarOpen: false,
  snackbarMessage: ''
}

const mutations = {
  OPEN_PRODUCTS_CONFIG_DIALOG(state) {
    state.productsConfigDialog = true
  },
  CLOSE_PRODUCTS_CONFIG_DIALOG(state) {
    state.productsConfigDialog = false
  },
  SET_CURRENT_PAGE(state, currentPage) {
    state.currentPage = currentPage
  },
  SET_SNACKBAR_COLOR(state, color) {
    state.snackbarColor = color
  },
  SET_SNACKBAR_OPEN(state, open) {
    state.snackbarOpen = open
  },
  SET_SNACKBAR_MESSAGE(state, message) {
    state.snackbarMessage = message
  }
}

const actions = {
  openProductsConfigDialog: ({ commit }) => {
    commit('OPEN_PRODUCTS_CONFIG_DIALOG')
  },
  closeProductsConfigDialog: ({ commit }) => {
    commit('CLOSE_PRODUCTS_CONFIG_DIALOG')
  },
  setCurrentPage: ({ commit }, currentPage) => {
    commit('SET_CURRENT_PAGE', currentPage)
  },
  setSnackbarColor: ({ commit }, color = 'red') => {
    commit('SET_SNACKBAR_COLOR', color)
  },
  setSnackbarOpen: ({ commit }, open) => {
    commit('SET_SNACKBAR_OPEN', open)
  },
  setSnackbarMessage: ({ commit }, message) => {
    commit('SET_SNACKBAR_MESSAGE', message)
  }
}

const getters = {
  productsConfigDialog(state) {
    return state.productsConfigDialog
  },
  currentPage(state) {
    return state.currentPage
  },
  snackbarColor(state) {
    return state.snackbarColor
  },
  snackbarOpen(state) {
    return state.snackbarOpen
  },
  snackbarMessage(state) {
    return state.snackbarMessage
  },
  colorClass(state) {
    return state.snackbarOpen ? state.snackbarColor : ''
  },
  isDark(state) {
    return state.snackbarOpen
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js